import { sharedConfigRoutes } from '../../config';
const { RouteName } = sharedConfigRoutes;
export const getTokenRoute = (tokenAddress) => (`${RouteName.TOKEN_PAGE}?tokenAddress=${tokenAddress}`);
